import React from "react";
import Artist from ".";

export const artistRoute = () => [
  {
    path: "/:lang/admin/artist",
    title: "My Event",
    layout: "admin",
    routeType: "admin",
    component: Artist,
  },
];
